import React, { useState, useEffect, memo } from "react";
import {
  faPlusCircle,
  faEye,
  faUnlink,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";

import { firestore, auth } from "../../../../../firebase";
import { postData } from "../../../../../utils";
import { API_BASE_URL, ADMIN_GET_APP_LIST } from "../../../../../config";
import QuizCreate from "./Quiz/Create";
import ListLoader from "./ListLoader";

function Quiz(props) {
  // CONSTANTS
  const {
    eventId,
    currentEvent,
    module_data,
    handleAddSubModule,
    handleRemoveSubModule,
    handleCloseQuizView,
  } = props;

  // STATES
  const [key, setKey] = useState("select");
  const [quizzes, setQuizzes] = useState([]);
  const [fetchingQuizzes, setFetchingQuizzes] = useState(true);

  // FUNCTIONS

  const handleFetchQuizzes = async () => {
    try {
      const response = await postData(`${API_BASE_URL}${ADMIN_GET_APP_LIST}`, {
        event_id: eventId,
        user_id: auth.currentUser.uid,
        types: ["quiz"],
      });

      if (response.status === 200) {
        const { data } = response;

        setQuizzes(data.quizList);
        setFetchingQuizzes(false);
      } else {
        setFetchingQuizzes(false);
      }
    } catch (error) {
      console.log("[Error] Fetching quizzes: ", error);
      setFetchingQuizzes(false);
    }
  };

  useEffect(() => {
    let unsubscribe_quizzes = firestore
      .collection(`/events/${eventId}/quizzes`)
      .onSnapshot((snapshot) => {
        snapshot.docChanges().forEach(() => {
          // Fetch: Quizzes
          handleFetchQuizzes();
        });
      });

    return () => {
      unsubscribe_quizzes();
    };
  }, []);

  return (
    <div style={{ height: "100%", overflowY: "scroll" }}>
      <div className="d-flex align-items-center">
        <a
          onClick={handleCloseQuizView}
          style={{ cursor: "pointer" }}
          className="text-white p-3 m-0"
          title="Close"
        >
          <FontAwesomeIcon icon={faTimes} />
        </a>
        <div className="p-3">
          <h4 className="text-white mb-2">Select a quiz or add new</h4>
          <p className="text-uppercase text-light small m-0">
            <strong>MODULE</strong> {module_data?.name}
          </p>
        </div>
      </div>
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="w-100"
      >
        <Tab
          tabClassName={
            key === "select"
              ? "border-top-0 border-left-0 border-right-0 border-bottom border-primary w-50 bg-transparent text-primary font-weight-bold"
              : "border-top-0 border-left-0 border-right-0 border-bottom border-secondary w-50 bg-transparent text-secondary font-weight-bold"
          }
          eventKey="select"
          title="Select from existing"
        >
          <div className="p-3">
            {fetchingQuizzes && <ListLoader />}
            <div className="mb-3">
              {quizzes?.map((quiz, key) => (
                <div
                  key={key}
                  className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                >
                  <div>
                    <p className="mb-0">
                      {/* {key + 1}.  */}
                      {currentEvent && currentEvent?.slug && (
                        <a
                          href={`${window.location.origin}/event/${currentEvent?.slug}/quiz/${quiz.content_id}`}
                          target="_blank"
                          className="text-secondary mr-2 pointer"
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </a>
                      )}

                      {quiz.title}
                    </p>
                  </div>
                  <div>
                    {module_data?.sub_modules?.filter(
                      (item) => item.content_id === quiz.content_id
                    )?.length > 0 ? (
                      <div
                        className="pointer"
                        onClick={() =>
                          handleRemoveSubModule(
                            module_data?.sub_modules?.filter(
                              (item) => item.content_id === quiz.content_id
                            )[0]
                          )
                        }
                      >
                        <FontAwesomeIcon
                          icon={faUnlink}
                          className="my-0 mr-2 pointer text-danger"
                        />
                        <small>REMOVE</small>
                      </div>
                    ) : (
                      <div
                        className="pointer"
                        onClick={() =>
                          handleAddSubModule({
                            reference_id: quiz.id,
                            content_id: quiz.content_id,
                            title: quiz.title,
                            type: "quiz",
                            user_id: auth.currentUser.uid,
                            order_index: module_data?.sub_modules?.length
                              ? module_data?.sub_modules?.length + 1
                              : 1,
                            event_id: eventId,
                            module_id: module_data?.id,
                          })
                        }
                      >
                        <FontAwesomeIcon
                          icon={faPlusCircle}
                          className="my-0 mr-2 pointer text-primary"
                        />
                        <small>ADD</small>
                      </div>
                    )}
                  </div>
                </div>
              ))}

              <button
                className="btn btn-primary btn-sm"
                onClick={() => setKey("create")}
              >
                <FontAwesomeIcon icon={faPlusCircle} /> Add new Quiz
              </button>
            </div>
          </div>
        </Tab>
        <Tab
          tabClassName={
            key === "create"
              ? "border-top-0 border-left-0 border-right-0 border-bottom border-primary w-50 bg-transparent text-primary font-weight-bold"
              : "border-top-0 border-left-0 border-right-0 border-bottom border-secondary w-50 bg-transparent text-secondary font-weight-bold"
          }
          eventKey="create"
          title="Create"
        >
          <div className="p-3">
            <QuizCreate module_id={module_data?.id} />
          </div>
        </Tab>
      </Tabs>
    </div>
  );
}

const mapStateToProps = (state) => ({
  eventId: state.eventId,
  currentEvent: state.currentEvent,
});

export default memo(connect(mapStateToProps)(Quiz));
